import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from '@xstyled/styled-components';
import { getSize, getColor } from '@lib/common';
import { Input, Tooltip } from 'antd';
import Image from 'next/image';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n  padding: ", " ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid #e2ebf0;\n"])), getSize('padding12'), getSize('padding12'), getSize('padding16'), getSize('radiusSm'));
var StyledInput = styled(Input)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  height: 40px;\n  border-radius: ", ";\n  border-color: #cbd5e1;\n\n  &:hover,\n  &:focus,\n  &.ant-input-focused {\n    border-color: ", ";\n  }\n\n  &:disabled {\n    background-color: #f8fafc;\n    cursor: not-allowed;\n  }\n"])), getSize('radiusS'), getColor('fillIntActive'));
var StyledActionButtonWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  transition: all 0.2s ease;\n  cursor: pointer;\n  flex-shrink: 0;\n"])), getSize('radiusS'));
var StyledIndexPrefix = styled.strong(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #2563eb;\n  flex-shrink: 0;\n"])), getSize('typo14'));
export var AnswerItem = function AnswerItem(_ref) {
  var type = _ref.type,
      index = _ref.index,
      answer = _ref.answer,
      onUpdate = _ref.onUpdate,
      onDelete = _ref.onDelete,
      readonly = _ref.readonly,
      matchingLabel = _ref.matchingLabel;
  return /*#__PURE__*/_jsxs(StyledLayout, {
    children: [/*#__PURE__*/_jsxs(StyledIndexPrefix, {
      children: [String.fromCharCode(65 + index), "."]
    }), /*#__PURE__*/_jsx(StyledInput, {
      defaultValue: answer.description || '',
      onChange: function onChange(e) {
        return onUpdate(e.target.value);
      },
      placeholder: "Enter option...",
      disabled: readonly
    }), onDelete && !readonly && /*#__PURE__*/_jsx(Tooltip, {
      title: matchingLabel.deleteAnswer,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        onClick: onDelete,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/icons/delete.svg",
          width: 16,
          height: 16,
          alt: "delete"
        })
      })
    })]
  });
};